import { FEATURES, ComponentProps } from '@portalCommon/constants/';
import classnames from 'classnames/bind';
import { OptimizedImg } from '@commonPackage/components';
import { ModuleTitle } from '../../styles';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const FuncText = ({ title, desc, isRight }: { title: string; desc: string[]; isRight: boolean }) => {
  const props = isRight ? { marginLeft: 56 } : { marginRight: 56 };

  return (
    <div className={cx('func-text-container')} style={props}>
      <div className={cx('func-title')}>{title}</div>
      <div className={cx('func-desc')}>
        {desc.map(item => {
          return (
            <div className={cx('func-desc-item')} key={item}>
              <div className={cx('func-dot')}>
                <div className={cx('dot')} />
              </div>
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const Features = ({ type, title, subtitle }: ComponentProps) => {
  return (
    <div className={cx('features-container')}>
      <ModuleTitle marginBottom={16} marginTop={36}>
        {title[0]}
        <span className={cx('highlight')}>{title[1]}</span>
      </ModuleTitle>
      <div className={cx('subtitle')}>{subtitle}</div>
      {FEATURES[type].map(item => {
        return item.rightText ? (
          <div key={item.title} className={cx('func-card')}>
            <OptimizedImg loading="lazy" style={{ borderRadius: 8 }} width={750} src={item.image} />
            <FuncText isRight={item.rightText} title={item.title} desc={item.desc} />
          </div>
        ) : (
          <div key={item.image} className={cx('func-card')} style={{ background: '#f6f8fc' }}>
            <FuncText isRight={item.rightText} title={item.title} desc={item.desc} />
            <OptimizedImg loading="lazy" style={{ borderRadius: 8 }} width={750} src={item.image} />
          </div>
        );
      })}
    </div>
  );
};
